import * as React from "react";
import { AutoCompleteInput, Checkbox, ColorPicker, Input, useAlert } from "uxp/components";
import { findAvailableFields, IUIPropertyDefinition } from "../../../common/common";
import { CustomColorPicker, Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyGroupTitle, PropertyTitle } from "../../../common/ui-props/common";
import jp from 'jsonpath'
import classNames from "classnames";
import { bindContainerId } from "../../../../util";
import { DataSourcePropertyEditor } from "../../../common/ui-props/DataSourceProperty";
import { IDataSource, IDataSourceBinding } from "../../../common/data-source-picker/datasource";
import { WidgetDesignerPillInput } from "../../../common/pill-input/PillInput";

export interface IFieldProperties {
    text: string;
    color: string;
    fieldName: string;
    datasource: IDataSourceBinding;
    useFieldAsTotal: boolean;
}

export function FieldProperties(fieldName: string, props: IFieldProperties): IUIPropertyDefinition<IFieldProperties> {
    return {
        defaults: props,
        render: (props, uxpContext, contextData, containerId) => {

            let _props = props.uiProps

            let possibleValues = {};
            findAvailableFields(_props.datasource, props.parentUIProps.datasources, possibleValues);
            let pv = Object.keys(possibleValues);
            pv.sort();


            let sources: IDataSource[] = props?.parentUIProps?.datasources

            console.log('datasources', sources)

            return (
                <PropertyContainer>
                    <PropertyContainerTitle>{fieldName}</PropertyContainerTitle>
                    <PropertyGroup>
                        <Property id={bindContainerId(fieldName + '-dataSource', containerId)}>
                            <DataSourcePropertyEditor
                                title={'Source'}
                                binding={_props.datasource}
                                sources={sources}
                                target={'dictionary'}
                                onChange={s => {
                                    jp.apply(_props, '$.datasource', () => (s))
                                    props.onChange(_props)
                                }}
                                designer={props.designer}
                                onChangeAny={props.onChangeAny}
                                context={props.uxpContext}
                                contextData={props.contextData}
                            />
                        </Property>
                    </PropertyGroup>
                    <PropertyGroup>
                        <Property id={bindContainerId(fieldName + '-name', containerId)}>
                            <PropertyTitle>Field Name</PropertyTitle>
                            <AutoCompleteInput
                                value={_props.fieldName || ''}
                                onChange={s => {
                                    jp.apply(_props, '$.fieldName', () => (s))
                                    props.onChange(_props)
                                }}
                                className="widget-designer-input"
                                options={pv}
                            />
                        </Property>

                        <Property>
                            <PropertyTitle>Label</PropertyTitle>
                            <WidgetDesignerPillInput
                                value={_props.text || ''}
                                onChange={s => {
                                    jp.apply(_props, '$.text', () => (s))
                                    props.onChange(_props)
                                }}
                                contextData={contextData}
                            />
                        </Property>
                        <Property>
                            <PropertyTitle>Text Color</PropertyTitle>
                            <CustomColorPicker contextData={props.contextData}
                                color={_props.color || 'white'}
                                onChange={s => {
                                    jp.apply(_props, '$.color', () => (s))
                                    props.onChange(_props)
                                }}
                            />
                        </Property>
                        <Property>
                            <Checkbox
                                checked={_props?.useFieldAsTotal}
                                onChange={s => {
                                    jp.apply(_props, '$.useFieldAsTotal', () => (s))
                                    props.onChange(_props)
                                }}
                                label="Use this field as total"
                            />
                        </Property>
                    </PropertyGroup>
                </PropertyContainer>
            )
        }
    };
}
